import { put, takeLatest, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import { Types, Creators as CreditCardCreators } from '../../reducers/creditCard';
import { getState } from '../../utils/getState';

function* getBalancePending() {
  try {
    const { creditCard } = yield select(getState);

    yield put(
      CreditCardCreators.getInstallmentRequest(
        creditCard.getIn(['creditCard', 'valor']) + creditCard.getIn(['totalPending'])
      )
    );
  } catch (error) {
    yield put(CreditCardCreators.getBalancePendingError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.GET_BALANCE_PENDING_REQUEST, getBalancePending);
}
